import { useState } from 'react';
import { shouldShowLocalOriginHint } from '../sessionNotices';
import { AuthErrorBanner } from './fieldError';

/**
 * Shown on /login after a sign-in that worked at the identity provider but
 * whose API session was not accepted (see sessionNotices). Without it the app
 * bounces back to the form and looks as if nothing happened.
 *
 * Purely presentational: no navigation, no storage writes, so showing or
 * dismissing it can never trigger another redirect.
 *
 * The developer hint appears only on a loopback host over plain http, where the
 * Secure session cookie is dropped; real users never see it.
 */
export function SessionNotEstablishedNotice({
  className,
}: {
  className?: string;
}) {
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) return null;
  return (
    <AuthErrorBanner className={className}>
      <span className="block">
        You signed in, but the app could not start your session. Try again; if
        it keeps happening, tell your admin.
      </span>
      {shouldShowLocalOriginHint() && (
        <span className="mt-1 block" data-testid="local-origin-hint">
          Developer hint: open https://app.biasafe.localhost instead of this
          address; the session cookie is only accepted over https.
        </span>
      )}
      <button
        type="button"
        className="mt-1 underline"
        onClick={() => setDismissed(true)}
      >
        Dismiss
      </button>
    </AuthErrorBanner>
  );
}
